import CCActivity from "./CCActivity";
import { CCAttestation } from "./CCAttestation";
import CCBlockEvaluationTernaryRequirement from "./CCBlockEvaluationTernaryRequirement";
import { EnrollmentCertificate } from "./CCEnrollment";

export class CCBlock {
    ccBlockId: number;
    ccBlockNumber: number;
    startDate: string;
    endDate: string;
    startYear: number;
    endYear: number;
    complete: boolean;
    extensionDate: string;
    totalCMEAttestationCredits: number;
    totalSAAttestationCredits: number;
    totalVerifiedCMECredits: number;
    totalVerifiedSACredits: number;
    hasPipClinicalAttestation: boolean;
    hasPipFeedbackAttestation: boolean;
    hasPatientSafetyCompleted: boolean;
    hasVerifiedPatientSafety: boolean;
    isExpanded: boolean;
    totalRequiredCMECredits: number;
    requiredCMECredits: number;
    requiredSACredits: number;
    totalWaivedCMECredits: number;
    totalWaivedSACredits: number;
    hasPipWaiver: boolean;
    ccVerifiedActivities: Array<CCActivity>;
    ccAppliedWaivers: Array<CCAttestationWaiver>;
    ccAppliedArticleWaivers: Array<CCArticleWaiver>;
    ccAttestations: Array<CCAttestation>;
    isEditing: boolean;
    ccAnnualFees: Array<CCAnnualFee>;
    totalBlockYears: number;
    isMeetingRequirements: boolean;
    isPatientSafetyRequired: CCBlockEvaluationTernaryRequirement;
    isPipRequired: boolean;
    outstandingRequirements: Array<CCBlockRequirementResult>;
    isActivityRequirementsCompleted: boolean;
    hasFailedAudit: boolean;
    hasPassedAudit: boolean;
    hasAudit: boolean;
    auditStart: string;
    pendingExamYear: number;
    enrollmentCertificates:  Array<EnrollmentCertificate>;
    unpaidOrphanYears: Array<number>;
    clinicalStatus: number;
    ccSummaryDashboard: CCSummaryDashboardActivities;
}

export class CCAttestationWaiver {
    ccAttestationWaiverId: number;
    cmeCredits: number;
    description: string;
    waiverTypeDescription: string;
    isPipWaived: boolean;
    saCredits: number;
    waiverDate: Date;
    year: number;
}

export class CCArticleWaiver {
    ccArticleWaiverId: number;
    certificateId: number;
    articleCredits: number;
    description: string;
    waiverDate: Date;
    year: number;
}

export class CCAnnualFee {
    year: number;
    isWaived: boolean;
    isPaid: boolean;
    feeAmount: number;
}
export class CCBlockRequirementResult {
    requirementType: CCBlockRequirementType;
}

export class CCSummaryDashboardActivities{
        isCMEComplete: boolean;
        isPIPComplete: boolean;
        isSaCMEComplete: boolean;
        isPatSafetyComplete: boolean;
    }

export enum CCBlockRequirementType {
    CME = 1,
    SA = 2,
    PIP = 3,
    PatientSafety = 4,
    MedicalLicense = 5,
    Fees = 6,
    FailedAudit = 8
}

export const ClinicalStatus: { [key: number]: string } = {
    2: "Clinically Active",
    3: "Clinically Inactive",
    6: "Clinically Active Not Enough For PIP"
}